module.exports = __webpack_public_path__ + "assets/img/INICIO.87a40393.svg";